var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'sm:f--ml-2': _vm.singleColumn,
    'f-col-span-2': true,
    'f-pl-2.5': true,
  }},[_c('BaseCheckbox',{staticClass:"fapi-form-show-company-base-checkbox",class:{ 'sm:f-ml-32': _vm.singleColumn },attrs:{"name":_vm.$id('show_full_form.name'),"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(" "+_vm._s(_vm.$t("basic_info.show_full_form.label"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }